export default "__VITE_ASSET__66zi10gf__"